import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  headerInfo: {
    title:'',
    subtitle:''
  },
}

/** Define your slicers here */
export const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setHeaderInfo: (state,action) => {
      state.headerInfo  = {...state.headerInfo , ...action.payload}
    }
  },
})

export const { setHeaderInfo } = commonSlice.actions;

export default commonSlice.reducer;